import React from "react";
import Edit from "../../../../assets/images/editinput.svg";
import PropTypes from 'prop-types';
import {Button} from "@appkit4/react-components/button";
import "../../../../styles/businessUser.css";

function AddMoreSpocs(props) {
  let {
    role,
    handleClickAddButton,
    additionalSpoc,
    handleRemoveButton,
    handleChangeFirstNameAdditional,
    handleChangeLastNameAdditional,
    handleChangePhoneAdditional,
    handleChangeEmailAdditional,
    handleChangeDesignationAdditional,
    editScreen
  } = props;
  let disabledFields;
  let disabledFieldsVendorContact = false;
  let tempCount = 0;
  if (role === "analyst" || role === "manager") {
    disabledFields = true
  }
  else {
    disabledFields = false //Can be changed according to future requirement.
  }
  if (role === "businessUser") {
    disabledFieldsVendorContact = true;
  }
  return (
    <>
    {editScreen ? (
      <div>
      {additionalSpoc?.map((item, index) => {
          tempCount = tempCount +1;
          return (
              <>
              <div className={index === 0 ? "row m-0" : "row positionTop"}>
      <div className="col-sm-6">
        <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
          <label htmlFor="FirstNameSpocs" className="cv-input-label">
            First Name
          </label>
              <input
                className={disabledFields ? "cv-input-field-disabled pl-2" :"cv-input-field pl-2"}
                type="text"
                id="FirstNameSpocs"
                value={item.firstNameAdditional}
                name="firstName"
                placeholder="Please enter first name"
                disabled={disabledFields}
                onChange={(e) => handleChangeFirstNameAdditional(e, index, item)}
              ></input>
              <img alt="edit" src={Edit} className="edit-input" />
        </div>
      </div>

      <div className="col-sm-6">
        <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
          <label htmlFor="LastNameSpocs" className="cv-input-label">
            Last Name
          </label>
          <input
            className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
            type="text"
            id="LastNameSpocs"
            value={item.lastNameAdditional}
            name="lastName"
            placeholder={"Please enter Last Name"}
            disabled={disabledFields}
            onChange={(e) => handleChangeLastNameAdditional(e, index, item)}
          />
          <img alt="edit" src={Edit} className="edit-input" />
        </div>
      </div>
    </div>
    <div className="row m-0">
      <div className="col-sm-6">
        <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
          <label htmlFor="BusinessDesignationSpocs" className="cv-input-label">
            Business Designation
          </label>
          <input
            className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
            type="text"
            id="BusinessDesignationSpocs"
            value={item.businessDesignationAdditional}
            name="vendorname"
            placeholder={"Please enter Business Designation"}
            disabled={disabledFields}
            onChange={(e) => handleChangeDesignationAdditional(e, index, item)}
          />
          <img alt="edit" src={Edit} className="edit-input" />
        </div>
      </div>
      <div className="col-sm-6">
        <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
          <label htmlFor="EmailSpocs" className="cv-input-label">
            Email<span className="asterisk-required">*</span>
          </label>
          <input
            className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
            type="email"
            id="EmailSpocs"
            value={item.emailAdditional}
            name="email"
            placeholder={"Please enter Email"}
            disabled={disabledFields}
            onChange={(e) => handleChangeEmailAdditional(e, index, item)}
          />
          <img alt="edit" src={Edit} className="edit-input" />
        </div>
      </div>
    </div>
    <div className="row m-0">
      <div className="col-sm-6">
        <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
          <label htmlFor="PhoneNumberSpocs" className="cv-input-label">
            Phone Number
          </label>
          <input
            className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
            type="tel"
            id="PhoneNumberSpocs"
            value={item.phoneNumberAdditional}
            name="vendorPhoneNumber"
            placeholder={"Please enter Phone Number"}
            disabled={disabledFields}
            onChange={(e) => handleChangePhoneAdditional(e, index, item)}
          />
          <img alt="edit" src={Edit} className="edit-input" />
        </div>
      </div>
    </div>
    </>
          )
      })}
      {role === "businessUser" ? (
        <>
        {additionalSpoc?.length < 8 ? (
          <div className="row buttonPosition">
            <div className="col-sm-6">
            <Button
            kind='negative'
            size='lg'
            className="addSpocButton"
            onClick={handleClickAddButton}
            >
            Add Entry
            </Button>
            {additionalSpoc.length > 1 ? (
                <Button className='removeButtonSpoc removeRadius'
                kind='secondary' size='lg' onClick={() => handleRemoveButton(tempCount)}>Remove</Button>
            ) : ("")}
            </div>
            </div>
      ) : (
          <div className="row buttonPosition">
          <div className="col-sm-6">
              <Button
            kind='negative'
            size='lg'
            className="addSpocButton"
            onClick={handleClickAddButton}
            disabled
            >
            Add Entry
            </Button>
            <Button className='removeButtonSpoc removeRadius'
                kind='secondary' size='lg'
                onClick={() => handleRemoveButton(tempCount)}
                >Remove</Button>
          </div>
          </div>
      )}
      </>
      ) : ("")}
  </div>
    ) : (
      <div>
      {additionalSpoc.additionalSpocData?.map((item, index) => {
          tempCount = tempCount +1;
          return (
              <>
              <div className={index === 0 ? "row m-0" : "row positionTop"}>
      <div className="col-sm-6">
        <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
          <label htmlFor="FirstNameSpocs" className="cv-input-label">
            First Name
          </label>
              <input
                id="FirstNameSpocs"
                className={disabledFields ? "cv-input-field-disabled pl-2" :"cv-input-field pl-2"}
                type="text"
                value={item.firstNameAdditional}
                name="firstName"
                placeholder="Please enter first name"
                disabled={disabledFields}
                onChange={(e) => handleChangeFirstNameAdditional(e, index, item)}
              ></input>
              <img alt="edit" src={Edit} className="edit-input" />
        </div>
      </div>

      <div className="col-sm-6">
        <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
          <label htmlFor="LastNameSpocs" className="cv-input-label">
            Last Name
          </label>
          <input
            className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
            type="text"
            id="LastNameSpocs"
            value={item.lastNameAdditional}
            name="lastName"
            placeholder={"Please enter Last Name"}
            disabled={disabledFields}
            onChange={(e) => handleChangeLastNameAdditional(e, index, item)}
          />
          <img alt="edit" src={Edit} className="edit-input" />
        </div>
      </div>
    </div>
    <div className="row m-0">
      <div className="col-sm-6">
        <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
          <label htmlFor="BusinessDesignationSpocs" className="cv-input-label">
            Business Designation
          </label>
          <input
            className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
            type="text"
            id="BusinessDesignationSpocs"
            value={item.businessDesignationAdditional}
            name="vendorname"
            placeholder={"Please enter Business Designation"}
            disabled={disabledFields}
            onChange={(e) => handleChangeDesignationAdditional(e, index, item)}
          />
          <img alt="edit" src={Edit} className="edit-input" />
        </div>
      </div>
      <div className="col-sm-6">
        <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
          <label htmlFor="EmailSpocs" className="cv-input-label">
            Email<span className="asterisk-required">*</span>
          </label>
          <input
            className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
            type="email"
            id="EmailSpocs"
            value={item.emailAdditional}
            name="email"
            placeholder={"Please enter Email"}
            disabled={disabledFields}
            onChange={(e) => handleChangeEmailAdditional(e, index, item)}
          />
          <img alt="edit" src={Edit} className="edit-input" />
        </div>
      </div>
    </div>
    <div className="row m-0">
      <div className="col-sm-6">
        <div className={disabledFields || disabledFieldsVendorContact ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
          <label htmlFor="PhoneNumberSpocs" className="cv-input-label">
            Phone Number
          </label>
          <input
            className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
            type="tel"
            id="PhoneNumberSpocs"
            value={item.phoneNumberAdditional}
            name="vendorPhoneNumber"
            placeholder={"Please enter Phone Number"}
            disabled={disabledFields}
            onChange={(e) => handleChangePhoneAdditional(e, index, item)}
          />
          <img alt="edit" src={Edit} className="edit-input" />
        </div>
      </div>
    </div>
    </>
          )
      })}
      {role === "businessUser" ? (
        <>
          {additionalSpoc.additionalSpocData?.length < 8 ? (
          <div className="row buttonPosition">
            <div className="col-sm-6">
            <Button
            kind='negative'
            size='lg'
            className="addSpocButton"
            onClick={handleClickAddButton}
            >
            Add Entry
            </Button>
            {additionalSpoc.additionalSpocData.length > 1 ? (
                <Button className='removeButtonSpoc removeRadius'
                kind='secondary' size='lg' onClick={() => handleRemoveButton(tempCount)}>Remove</Button>
            ) : ("")}
            </div>
            </div>
      ) : (
          <div className="row buttonPosition">
          <div className="col-sm-6">
              <Button
            kind='negative'
            size='lg'
            className="addSpocButton"
            onClick={handleClickAddButton}
            disabled
            >
            Add Entry
            </Button>
            <Button className='removeButtonSpoc removeRadius'
                kind='secondary' size='lg'
                onClick={() => handleRemoveButton(tempCount)}
                >Remove</Button>
          </div>
          </div>
      )}
        </>
      ) : ("")} 
  </div>)}
  </>
)
}
AddMoreSpocs.propTypes = {
  role:PropTypes.string,
  handleClickAddButton: PropTypes.any,
  setAdditionalSpoc: PropTypes.any,
  additionalSpoc: PropTypes.any,
  handleRemoveButton: PropTypes.any,
  handleChangeFirstNameAdditional: PropTypes.any,
  handleChangeLastNameAdditional: PropTypes.any,
  handleChangeDesignationAdditional: PropTypes.any,
  handleChangeEmailAdditional: PropTypes.any,
  handleChangePhoneAdditional: PropTypes.any,
  editScreen: PropTypes.any
  }
export default AddMoreSpocs;
